/**
 * "This browser has visited the hidden admin URL" marker.
 *
 * NoJo Enterprise deliberately ships without a login system to keep
 * the attack surface small. The internal sync-status page lives at a
 * hidden URL (`/admin/sync-status`) — anyone who knows the URL can
 * visit it, but the data it exposes is read-only and PII-free, so
 * security-by-obscurity is an acceptable tradeoff.
 *
 * To give the operator one-click navigation back to the page on
 * subsequent visits *without* exposing a "Sync" link to every
 * customer who lands on the homepage, we set a small localStorage
 * marker the first time anyone visits the hidden URL. The header pill
 * is then conditioned on that marker — visible only to browsers that
 * have been to the admin page before.
 *
 * The marker is just a boolean flag (no token, no secret) — anyone
 * inspecting their own browser storage could set it manually to
 * unhide the pill, but the page itself is reachable directly via the
 * URL anyway, so there's nothing to "leak".
 */

const STORAGE_KEY = "nojo.admin.visited.v1";

export function markAdminVisited() {
  try {
    window.localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    /* localStorage unavailable (private mode etc) — the page itself
       still works, the header pill just won't appear in this session */
  }
}

export function clearAdminVisited() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch { /* noop */ }
}

export function isAdminBrowser() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}
